import {
  useParams as useReactRouterParams,
  useSearchParams as useReactRouterSearchParams
} from "react-router-dom"
import { z } from "zod"

/**
 * Validates react-router-dom path and search params.
 */
export const useRouteParams = <
  PathShape extends z.ZodRawShape,
  SearchShape extends z.ZodRawShape
>({
  path = {} as PathShape,
  search = {} as SearchShape
}: {
  path?: PathShape
  search?: SearchShape
}) => {
  const params = useReactRouterParams()
  const validatedPath = z.object(path ?? {}).safeParse(params)
  if (!validatedPath.success)
    throw new ParamsValidationError(validatedPath.error)

  const searchParams = Object.fromEntries(useReactRouterSearchParams()[0])
  const validatedSearch = z.object(search ?? {}).safeParse(searchParams)
  if (!validatedSearch.success)
    throw new ParamsValidationError(validatedSearch.error)

  return {
    path: validatedPath.data,
    search: validatedSearch.data
  }
}

class ParamsValidationError extends Error {
  constructor(zodError: z.ZodError) {
    super(zodError.toString())
  }
}

export function isParamsValidationError(
  error: unknown
): error is ParamsValidationError {
  return error instanceof ParamsValidationError
}
